/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class consentreference extends IceEntity {
    consent_reference_key: string = "";
    external_data_key: string = "";
    login_user_name: string = "";
    account_type: IceTypes.ACCOUNT_TYPE.actNone;
    trans_account: string = "";
    title: string = "";
    sub_type: number = 0;
    code: string = "";
    override_consent: boolean = false;
    override_reason: string = "";
    record_version: number = 0;
    offline_record_status: number = 0;
    original_path: string = "";
    full_name: string = "";
    date_of_consent: any = NaN;
    note_status_type: IceTypes.notestatus = IceTypes.notestatus.statusCompleteRequired;

    gettablename(): string {
        return "CONSENT_REFERENCE";
    }
}
